import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/foneorders.com/app/src/client/components/ui/ClientToaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/foneorders.com/app/src/client/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/foneorders.com/app/src/client/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/foneorders.com/app/src/styles/tailwind.css");
